module.exports = __webpack_public_path__ + "img/ger_352_btn1.13e0537d.png";